import { observer } from "mobx-react-lite";

import { BodyInstructionsField } from "src/components/BodyInstructionsField";
import { TimedHeaderFields } from "src/components/TimedHeaderFields";

import {
  BaseDetailedWorkoutItemGroup,
  type WorkoutItemGroupProps,
} from "./BaseDetailedWorkoutItemGroup";

export const TimedDetailedWorkoutItemGroup = observer(
  function TimedDetailedWorkoutItemGroup(props: WorkoutItemGroupProps) {
    return (
      <BaseDetailedWorkoutItemGroup
        {...props}
        header={<TimedHeaderFields workoutItemId={props.item.workoutItemId} />}
        body={
          <BodyInstructionsField workoutItemId={props.item.workoutItemId} />
        }
      />
    );
  },
);
